import { getProductName } from '@components/MainWidget/ChallanWidgetLanding/helper'
import { campaignNameConfig } from '@components/MainWidget/common/commonWidgetConfig'
import { vehicleType } from '@components/WhatsappChallanFlow/helper'
import { WHATSAPP_CHALLAN_JOURNEY, WHATSAPP_CHALLAN_PAGE_TYPE } from '@components/WhatsappChallanNewFlow/enums'
import { getStateNameFromRegNum } from '@components/WhatsappChallanNewFlow/helper'

export const getWhatsAppChallanProperties = (isNonVahanState: boolean, utmLead: string, stateName: string) => ({
  page: WHATSAPP_CHALLAN_PAGE_TYPE.FINAL_PAGE,
  journey: isNonVahanState ? WHATSAPP_CHALLAN_JOURNEY.ULIP_SKIPPED : WHATSAPP_CHALLAN_JOURNEY.ULIP_CHECKED,
  utm_lead: utmLead,
  state_name: stateName,
  utm_campaign: campaignNameConfig?.[utmLead] || '',
})

export const getCommonWAChallanProperties = (utmLead, phoneNumber, regNum, vehicleData) => {
  const stateName = getStateNameFromRegNum(regNum)
  return {
    utm_lead: utmLead || '',
    utm_campaign: campaignNameConfig?.[utmLead] || '',
    product: getProductName(),
    phone: phoneNumber || '',
    registration_number: regNum || '',
    vehicle_type: vehicleType(vehicleData) || 'N/A',
    mm_name: vehicleData?.model_name,
    previous_policy_expiry_date: vehicleData?.previous_policy_expiry_detail,
    expiry_date: vehicleData?.previous_policy_expiry_detail || '',
    state_name: stateName,
  }
}
